import { Link } from "react-router-dom";
const s = (data) => {
    return data.data._3Headings.map(
        (dat, i) => 
<div className="col-12 col-lg-4" key={i}>
<div className="px-5 my-5"><img src={dat.image} className="w-50" alt="powered on podcast" /></div>
<div className="heading3">
<h4><Link to={`/view/${dat.uuid}`}>{dat.heading}</Link></h4><p className="description">{dat.content}</p>
</div>
</div>
    );
}

export default s;